import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/context/LangContext";

const FAQ = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-5">
            <div className="font-eyebrow text-2xl md:text-[30px] text-[#0F3D2E]/85 mb-6">{t.faq.eyebrow}</div>
            <h2 className="font-serif-editorial text-[#0F3D2E] leading-[0.95] text-[10vw] sm:text-[8vw] md:text-[4.8vw]">
              {t.faq.title.split("\n").map((l, i) => (
                <span key={i} className="block">
                  {i === 1 ? <em className="italic text-[#2E8B4A]">{l}</em> : l}
                </span>
              ))}
            </h2>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <ul className="divide-y divide-[#E5DFCE] border-t border-[#E5DFCE]">
              {t.faq.items.map((item, i) => (
                <li key={i} data-testid={`faq-item-${i}`}>
                  <button
                    type="button"
                    onClick={() => setOpen(open === i ? -1 : i)}
                    className="w-full py-6 flex items-start justify-between gap-6 text-left group"
                    data-testid={`faq-toggle-${i}`}
                    aria-expanded={open === i}
                  >
                    <span className="font-serif-editorial text-[#0F3D2E] text-xl md:text-2xl leading-snug pr-4">
                      {item.q}
                    </span>
                    <span className="mt-1 shrink-0 w-8 h-8 rounded-full border border-[#0F3D2E]/25 inline-flex items-center justify-center text-[#0F3D2E] group-hover:bg-[#0F3D2E] group-hover:text-[#FAF7F0] transition-colors">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                          d={open === i ? "M2 6h8" : "M6 2v8M2 6h8"}
                          stroke="currentColor"
                          strokeWidth="1.4"
                          strokeLinecap="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {open === i && (
                      <motion.div
                        key="content"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                        data-testid={`faq-content-${i}`}
                      >
                        <p className="pb-6 text-[14px] md:text-[15px] leading-relaxed text-[#0A1F17]/75 max-w-lg">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
